import * as updateMessageTemplate from '@/api/crm/messageTemplates/updateMessageTemplate';
import * as deleteMessageTemplate from '@/api/crm/messageTemplates/deleteMessageTemplate';
import * as addMessageTemplate from '@/api/crm/messageTemplates/addMessageTemplate';
import * as getMessageTemplatesForVenue from '@/api/crm/messageTemplates/getMessageTemplatesForVenue';


export default {
    namespaced: true,
    state: {
        messageTemplates: [],
        currentVenueId: null,
        loading: false,
    },
    mutations: {
        gotMessageTemplates(state, { result, venueId }) {
            console.log("Message templates", result, venueId);
            state.currentVenueId = venueId;
            state.messageTemplates = result;
        },
        isLoading(state, loading) {
            state.loading = loading;
        }
    },
    actions: {
        async add({ dispatch }, dto) {
            const result = await addMessageTemplate.post(dto);
            return result;
        },
        async update({ dispatch }, dto) {
            const result = await updateMessageTemplate.put(dto);
            return result;
        },
        async delete({ dispatch }, dto) {
            await deleteMessageTemplate.del(dto);
        },
        async getForVenue({ commit }, venueId) {
            commit("isLoading", true);
            const result = await getMessageTemplatesForVenue.get(venueId);
            if (result) commit("gotMessageTemplates", { result, venueId });
            commit("isLoading", false);
        },
    },
    getters: {
        isFetching: state => state.loading,
        messageTemplates: state => state.messageTemplates,
        messageTemplates_html: state => state.messageTemplates.filter(e => e.template.templateType == "Html"),
        messageTemplates_plain: state => state.messageTemplates.filter(e => e.template.templateType == "Plain"),
    }
};
